import script from "./ConsentManager.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConsentManager.vue?vue&type=script&lang=ts&setup=true"

import "./ConsentManager.vue?vue&type=style&index=0&id=b3aabd86&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3aabd86"]])

export default __exports__